.code {
    width: 100%;
    font-size: 12px;
    padding: 5px;
    font-family: monospace;
    resize: none;
    border-radius: 6px;
    border-color: #d4d4d5;
}